export default __webpack_public_path__ + "static/media/nedco.1a78c7d8.png";